import { HuesgesData } from '../../model/inspectionData';
import { SubmissionError } from 'redux-form';

import { serviceUrlHuesgesPost } from './urls';
import { createAxios } from './apiClient';

export const postHuesgesInspectionRequest = (inspectionId: string, formdata: HuesgesData) => {

  const data: HuesgesData = {
    ...(formdata as HuesgesData),
  };

  const instance = createAxios();
  return instance.post(serviceUrlHuesgesPost() + encodeURIComponent(inspectionId), data).catch((e: Error) => {
    throw new SubmissionError({
      _error: e.message,
    });
  });
};



// WEBPACK FOOTER //
// ./src/shared/api/huesgesApi.tsx